import { IStore } from 'store/configureStore';

export const selectSubmittingOrgState = (state: IStore) => {
    return state.modules.settings.clientsSettings.clients.submittingOrg;
};
